module.exports = __webpack_public_path__ + "img/클레릭.aefc1f1a.png";